import * as React from 'react';
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import MenuButton from 'elements/MenuButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import {
  PiGaugeLight,
  PiUsersLight,
  PiArrowsClockwiseLight,
  PiBellLight,
  PiWarehouseLight,
  PiPackageLight,
  PiSquaresFourLight,
  PiTruckLight,
  PiStarLight,
  PiChartBarLight,
  PiArrowsLeftRightLight,
  PiReceiptLight,
  PiAddressBookLight,
  PiWarningCircleLight,
  PiRocketLaunchLight,
  PiBuildingsLight,
  PiShieldCheckLight,
  PiListChecksLight,
  PiWalletLight,
  PiChartLineUpLight,
  PiHandCoinsLight,
  PiMapPinLight,
  PiClipboardTextLight,
  PiMapTrifoldLight,
  PiTreeStructureLight,
  PiFileTextLight,
  PiGearLight,
  PiArrowBendUpLeftLight,
  PiPathLight,
  PiCarLight,
  PiCompassLight,
  PiChartPieSliceLight,
  PiBriefcaseLight,
  PiCreditCardLight,
  PiFileArrowDownLight,
  PiCubeLight,
  PiStorefrontLight,
  PiShoppingCartLight,
  PiGlobeLight,
  PiPresentationChartLight,
  PiCalculatorLight,
  PiHouseLineLight,
  PiFlagLight,
  PiBookOpenLight,
  PiHandGrabbingLight,
  PiChatCircleLight,
  PiQuestionLight,
  PiSirenLight,
  PiMoneyLight,
  PiWrenchLight,
} from "react-icons/pi";



const iconMap: any = {
  'PiGaugeLight': <PiGaugeLight />,
  'PiUsersLight': <PiUsersLight />,
  'PiArrowsClockwiseLight': <PiArrowsClockwiseLight />,
  'PiBellLight': <PiBellLight />,
  'PiWarehouseLight': <PiWarehouseLight />,
  'PiPackageLight': <PiPackageLight />,
  'PiSquaresFourLight': <PiSquaresFourLight />,
  'PiTruckLight': <PiTruckLight />,
  'PiStarLight': <PiStarLight />,
  'PiChartBarLight': <PiChartBarLight />,
  'PiArrowsLeftRightLight': <PiArrowsLeftRightLight />,
  'PiReceiptLight': <PiReceiptLight />,
  'PiAddressBookLight': <PiAddressBookLight />,
  'PiWarningCircleLight': <PiWarningCircleLight />,
  'PiRocketLaunchLight': <PiRocketLaunchLight />,
  'PiBuildingsLight': <PiBuildingsLight />,
  'PiShieldCheckLight': <PiShieldCheckLight />,
  'PiListChecksLight': <PiListChecksLight />,
  'PiWalletLight': <PiWalletLight />,
  'PiChartLineUpLight': <PiChartLineUpLight />,
  'PiHandCoinsLight': <PiHandCoinsLight />,
  'PiMapPinLight': <PiMapPinLight />,
  'PiClipboardTextLight': <PiClipboardTextLight />,
  'PiMapTrifoldLight': <PiMapTrifoldLight />,
  'PiTreeStructureLight': <PiTreeStructureLight />,
  'PiFileTextLight': <PiFileTextLight />,
  'PiGearLight': <PiGearLight />,
  'PiArrowBendUpLeftLight': <PiArrowBendUpLeftLight />,
  'PiPathLight': <PiPathLight />,
  'PiCarLight': <PiCarLight />,
  'PiCompassLight': <PiCompassLight />,
  'PiChartPieSliceLight': <PiChartPieSliceLight />,
  'PiBriefcaseLight': <PiBriefcaseLight />,
  'PiCreditCardLight': <PiCreditCardLight />,
  'PiFileArrowDownLight': <PiFileArrowDownLight />,
  'PiCubeLight': <PiCubeLight />,
  'PiStorefrontLight': <PiStorefrontLight />,
  'PiShoppingCartLight': <PiShoppingCartLight />,
  'PiGlobeLight': <PiGlobeLight />,
  'PiPresentationChartLight': <PiPresentationChartLight />,
  'PiCalculatorLight': <PiCalculatorLight />,
  'PiHouseLineLight': <PiHouseLineLight />,
  'PiFlagLight': <PiFlagLight />,
  'PiBookOpenLight': <PiBookOpenLight />,
  'PiHandGrabbingLight': <PiHandGrabbingLight />,
  'PiChatCircleLight': <PiChatCircleLight />,
  'PiQuestionLight': <PiQuestionLight />,
  'PiMoneyLight': <PiMoneyLight />,
  'PiWrenchLight': <PiWrenchLight />,
};

export default function MainMenu(props: any) {
  const { permissions } = props;

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [expandedIndex, setExpandedIndex] = useState<number | false>(false);

  const handleAccordionChange = (index: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpandedIndex(isExpanded ? index : false); // Si es el acordeón abierto, se cierra; si no, se abre
  };

  // Filtrar solo los permisos visibles
  const visiblePermissions = permissions.filter((permission: any) => permission.isVisible !== false);

  return (
    <div className='menu_button_container'>
      {visiblePermissions.map((permission: any, index: number) => {
        const isDisabled = permission.isEnabled === false;
        return (
          <Accordion 
            key={index} 
            className='menuAccordion' 
            expanded={!isDisabled && expandedIndex === index} 
            onChange={!isDisabled ? handleAccordionChange(index) : undefined}
            disabled={isDisabled}
          >
            <AccordionSummary 
              expandIcon={ <ExpandMoreIcon sx={{color: isDisabled ? '#999' : '#1D3B47'}} />}
              className='menuAccordionItem'
              sx={{
                backgroundColor: expandedIndex === index ? '#F6F6F7' : '#FFF',
                paddingRight: '5px !important',
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                '&:hover': {
                  backgroundColor: isDisabled ? '#FFF' : undefined
                }
              }}
            >
              <div className='menuCategory'>
                {permission.category}
                {isDisabled && <span style={{marginLeft: '8px', fontSize: '0.75rem', color: '#999'}}>(No disponible)</span>}
              </div>
            </AccordionSummary>

            <AccordionDetails className='menuAccordionDetails'>
              <div className='submenu_container'>
                {permission.components.map((submenu: any, index2: number) => {
                  return (
                    <MenuButton 
                      key={submenu.path} 
                      label={submenu.label} 
                      to={isDisabled ? '#' : submenu.path} 
                      startIcon={iconMap[submenu.icon]}
                      disabled={isDisabled}
                    />     
                  );
                })}
              </div>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </div>
  );
}

